const About = () => (
  <div className="text-slate-300 leading-relaxed space-y-5 text-center md:text-left md:max-w-none">
    <p>
      Hi! I’m Devish, a Data Engineer focused on building cloud-agnostic data platforms that balance performance, governance, and scalability.
    </p>
    <p>
      My work spans Databricks (Delta + Unity Catalog), Spark (Scala/Python), and Terraform, creating pipelines that handle billions of events while staying compliant and cost-efficient.
    </p>
    <p>
      I’ve architected systems across AWS, Azure, and hybrid environments, ensuring that whether it’s a single cloud or multi-cloud setup, the lakehouse remains unified, automated, and auditable.
    </p>
    <p>
      What I enjoy most is simplifying complexity, turning messy telemetry and nested JSON into clear, governed Delta tables that power analytics and decisions you can trust.
    </p>
  </div>
);

export default About;
